import { Breadcrumb } from "@gull";
import { AppContext } from "app/appContext";
import HandyScroll from "app/common/Scroll";
import usePagePermission from "app/hooks/usePagePermission";
import { deactivateIp, getIP } from "app/services/ipService";
import {
  getCountryDetails,
  getMerchant,
  getStateDetails,
} from "app/services/memberService";
import queryString from "app/services/queryStringService";
import { default as config, default as enableEmulate } from "config.json";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { Helmet } from "react-helmet";
import { MdEdit } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import Swal from "sweetalert2";
import Tooltip from "rc-tooltip";
const { frontUrl } = config;

const IpVendorList = () => {
  const { canAdd, canEdit } = usePagePermission();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const [show, setShow] = useState(false);

  const [searchTrigger, setSearchTrigger] = useState(true);

  const actionFormatter = (cell, row) => {
    return (
      <>
        <DropdownButton variant="outline-primary" title="Action" size="sm">
          <Dropdown.Item>
            <Link
              style={{ width: "100%", textDecoration: "none" }}
              className="btn btn-link"
              to={`/admin/ip-vendor/edit/${row.id}`}
            >
              <MdEdit
                className="text-primary me-4"
                size={15}
                style={{ marginLeft: "-70%" }}
              ></MdEdit>
              Edit
            </Link>
          </Dropdown.Item>
        </DropdownButton>
      </>
    );
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="me-2">Page Size</label>
      <div className="btn-group me-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: dataCount > 0,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  const updateStatus = async (row) => {
    Swal.fire({
      title: `Are you sure you want to
    ${!row.status == false ? "inactive" : "active"}
     this IP Address?`,
      icon: "warning",
      type: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      showCancelButton: true,
      cancelButtonText: "No",
      showConfirmButton: true,
      confirmButtonText: "Yes",
      showLoaderOnConfirm: true,
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const requestData = { id: row.id, status: !row.status };

        const res = await deactivateIp(requestData);

        try {
          if (res.status === "Success") {
            NotificationManager.success(res.message);
            setTimeout(async () => {
              await loadMember();
            }, 10);
          } else {
            NotificationManager.error(res.message);
          }
        } catch (error) {
          NotificationManager.error(error);
        }
      },
    });
  };

  const setDefaultFormatter = (cell, row) => {
    return (
      <span>
        <div className="row ">
          <div className="col-md">
            <div
              className=" d-flex justify-content-center"
              style={{ cursor: "pointer" }}
            >
              <Tooltip
                style={{ marginLeft: "-1pc" }}
                placement="left"
                overlay={
                  row.isActive === false
                    ? "Status Inactive"
                    : row.isDefault === true
                    ? "Click to  Inactive"
                    : "Click to  Set Default"
                }
              >
                <span>
                  <Form.Check
                    type="switch"
                    id={`custom-switch${row.id}`}
                    onChange={() => updateStatus(row)}
                    checked={row?.status == true}
                  />
                </span>
              </Tooltip>
            </div>
          </div>
        </div>
      </span>
    );
  };

  const columns = [
    {
      dataField: "domainName",
      text: "Domain Name",
      headerStyle: () => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "ipAddress",
      text: "IP Address",
      headerStyle: () => {
        return { width: "180px", textAlign: "center" };
      },
    },
    {
      dataField: "macIPAddress",
      text: "MAC IP Address",
      headerStyle: () => {
        return {
          width: "200px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "member.memberFullName",
      text: "Member Name",
      headerStyle: () => {
        return {
          width: "150px",
          textAlign: "center",
        };
      },
    },

    {
      dataField: "status",
      text: "Status",
      headerStyle: () => {
        return { width: "200px", textAlign: "center" };
      },
      formatter: setDefaultFormatter,
    },
    {
      dataField: "id",
      text: "Action",
      headerStyle: () => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: actionFormatter,
    },
  ];

  const rowStyle = () => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadMember = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      // search,
    });

    const response = await getIP(query);

    const responseData = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setTimeout(() => {
      setData(responseData);
      setDataCount(paggingData.TotalCount);
      setPage(paggingData.CurrentPage);
      setSizePerPage(paggingData.PageSize);
      setLoading(false);
    }, 10);
  };

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
  };
  useEffect(() => {
    loadMember();
  }, [page, sizePerPage]);

  return (
    <>
      {canAdd && (
        <Link
          className="btn btn-primary btn-md float-end"
          to="/admin/ip-vendor/add"
        >
          <i className="i-Add-User text-white me-2"></i> Add IP Vendor
        </Link>
      )}
      <Helmet>
        <title>IP Vendor List</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "IP Vendor List" }]}></Breadcrumb>

      <HandyScroll>
        <div
          className="spacious-container"
          data-handy-scroll
          style={{ overflow: "auto" }}
        >
          <BootstrapTable
            hover
            remote
            keyField="uniqueIdentity"
            data={data}
            columns={
              canEdit ? columns : columns.filter((x) => x.text !== "Action")
            }
            pagination={dataCount > 0 && paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={() => <NoDataIndication />}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            rowStyle={rowStyle}
          />
        </div>
      </HandyScroll>
    </>
  );
};

export default IpVendorList;
